import moment, { Moment } from 'moment';
import { RangeValueType } from 'rc-picker/lib/PickerInput/RangePicker';

export const dateFormatter = (date: string | undefined | null, dateFormat: string = 'DD MMMM YYYY, HH:mm') =>
  date ? moment.utc(date).format(dateFormat) : '';
export const dateFormatterToUTC = (dateObject: Moment) => {
  const date = moment(dateObject).format('YYYY-MM-DD');
  const time = moment(dateObject).format('HH:mm:ss');

  return moment.utc(`${date}T${time}`).format();
};
export const dateDifference = (firstDate: string, secondDate: string) => moment(firstDate).diff(secondDate);
export const timeFormatter = (time: string | undefined | null, dateFormat: string = 'HH:mm') =>
  time ? moment(time, 'HH:mm:ss').format(dateFormat) : '';

export const rangeConfig: {
  label: React.ReactNode;
  value: RangeValueType<Moment>;
}[] = [
  { label: 'Today', value: [moment().startOf('day'), moment()] },
  {
    label: 'Yesterday',
    value: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
  },
  { label: 'This week', value: [moment().startOf('week'), moment().endOf('week')] },
  { label: 'This month', value: [moment().startOf('month'), moment().endOf('month')] },
  {
    label: 'Last week',
    value: [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
  },
  {
    label: 'Last month',
    value: [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')],
  },
  {
    label: 'Last 7 days',
    value: [moment().subtract(7, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
  },
  {
    label: 'Last 14 days',
    value: [moment().subtract(14, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
  },
  {
    label: 'Last 30 days',
    value: [moment().subtract(30, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
  },
];

export const formatTimeAgo = (createdAt: string): string => {
  const now = moment();
  const date = moment(createdAt);

  const diffSec = now.diff(date, 'seconds');
  const diffMin = now.diff(date, 'minutes');
  const diffHours = now.diff(date, 'hours');

  if (diffSec < 0) {
    return 'Just now';
  }

  if (diffSec < 60) {
    return `${diffSec} sec ago`;
  }

  if (diffMin < 60) {
    return `${diffMin} min${diffMin > 1 ? 's' : ''} ago`;
  }

  if (diffHours < 24) {
    return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`;
  }

  return date.format('MM/DD/YY');
};

export const CURRENT_YEAR = moment().year();
export const CURRENT_WEEK = moment().isoWeek();

export const YEAR_OPTIONS = Array.from({ length: 11 }, (_, i) => {
  const y = CURRENT_YEAR - 10 + i;
  return { label: String(y), value: y };
});

export const QUARTER_OPTIONS = [1, 2, 3, 4].map((q) => ({ label: `Q${q}`, value: q }));
export const MONTH_OPTIONS = moment.months().map((name, i) => ({ label: name, value: i + 1 }));

export const getWeekLabel = (w: number, effectiveYear: number): string => {
  if (effectiveYear === CURRENT_YEAR) {
    if (w === CURRENT_WEEK) {
      return 'Current week';
    }
    if (w === CURRENT_WEEK - 1) {
      return 'Last week';
    }
  }
  return `Week ${w}`;
};

export const dayFitsFilters = (d: Moment, year: number, quarter?: number, month?: number): boolean =>
  d.year() === year && (!quarter || d.quarter() === quarter) && (!month || d.month() + 1 === month);

export const getWeekOptions = (year?: number): { label: string; value: number }[] => {
  const effectiveYear = year ?? CURRENT_YEAR;
  const totalWeeks = moment(`${effectiveYear}-07-01`).isoWeeksInYear();
  const maxWeek = effectiveYear === CURRENT_YEAR ? CURRENT_WEEK : totalWeeks;
  const options = [];

  for (let w = maxWeek; w >= 1; w--) {
    options.push({ label: getWeekLabel(w, effectiveYear), value: w });
  }

  return options;
};
